var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgCart = function SvgCart(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 20h-14v-3h11.01c2.449 0 4.576-1.697 5.057-4.033l1.411-6.763A1.002 1.002 0 0 0 26 5H7.25l-.66-3.202A1 1 0 0 0 5.61 1H2a1 1 0 0 0 0 2h2.796L7.5 16.103v4.955c-.617.632-1 1.492-1 2.442 0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5a3.46 3.46 0 0 0-.351-1.5h7.202A3.46 3.46 0 0 0 20 23.5c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5Zm1.27-13-1.16 5.561C23.317 13.974 22.014 15 20.51 15H9.315L7.664 7h17.105ZM11.5 23.5c0 .827-.673 1.5-1.5 1.5s-1.5-.673-1.5-1.5S9.173 22 10 22s1.5.673 1.5 1.5Zm12 1.5c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5Z",
    fill: "currentColor"
  })));
};
export default SvgCart;